import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { LuUpload } from 'react-icons/lu';
import { ICandidateCVs, amplitude } from 'wisestep-api';
import {
  ScrollableTabs,
  TabTextVariant,
  WsButton,
  WsColors,
  formateDateForNewSubmission,
} from 'wisestep-base';

import { OtherDocuments, cvTabs } from '../../../utils/helper';
import CvCard from '../../childComponets/cvCard';
import DocumentCard from '../../childComponets/documentCard/DocumentCard';

import EmptyContentMessage from './EmptyContentMessage';
import UploadFile from './UploadFile';

interface LeftPAneProps {
  cvs: ICandidateCVs[];
  documents: OtherDocuments[];
  onSelect: (cv: string, fileType: string) => void;
  onSelectedCVName?: (resumeFileOriginalName: string) => void;
  amplitudeEventHandler?: (eventName: string) => void;
}
const LeftPane = ({ cvs, onSelect, documents, onSelectedCVName }: LeftPAneProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [currentTab, setCurrentTab] = useState<number>(0);
  const [otherDocuments, setOtherDocuments] = useState<OtherDocuments[]>([]);
  const [openUpload, setOpenUpload] = useState<boolean>(false);

  useEffect(() => {
    setOtherDocuments(documents);
  }, [documents]);

  const handleDocumentSelect = (index: number, document: OtherDocuments) => {
    setSelectedIndex(index);
    onSelect(document?.resumeLocation ?? document.documentLocation ?? '', 'application/pdf');
    onSelectedCVName?.(document?.resumeFileName ?? document.originalName ?? 'file');
  };

  const tabSlection = (i) => {
    setCurrentTab(i);
    if (i === 1 && otherDocuments.length > 0) {
      const firstDocument = otherDocuments[0];
      setSelectedIndex(0);
      onSelect(firstDocument?.resumeLocation ?? '', 'application/pdf');
      onSelectedCVName?.(firstDocument?.resumeFileName ?? 'file');
    }
  };

  return (
    <Grid container sx={{ background: WsColors.White }}>
      <Grid xs={12} item pt={2}>
        <WsButton
          size="large"
          fullWidth
          startIcon={<LuUpload size={16} />}
          onClick={() => setOpenUpload(true)}
        >
          Upload files
        </WsButton>
      </Grid>
      <Grid xs={12} item>
        <ScrollableTabs
          scrollList={cvTabs}
          getTabIndex={tabSlection}
          variant={TabTextVariant.SUB_TITLE}
          defaultValue={0}
        />
      </Grid>
      <Grid item xs={12}>
        {currentTab == 0 && (
          <>
            {cvs.length > 0 ? (
              cvs.map((cv, index) => (
                <CvCard
                  key={index}
                  title={cv?.documentFileName ?? ''}
                  source={cv?.source ?? ''}
                  jobTitle={cv.jobTitle ?? ''}
                  recruiterName={cv.documentUploadedBy ?? ''}
                  date={cv?.documentUploadedOn ?? ''}
                  jobcode={cv?.jobCode ?? ''}
                  isSelected={selectedIndex === index}
                  resumeUrl={cv?.documentLocation ?? ''}
                  onClick={() => {
                    setSelectedIndex(index);
                    onSelect(cv?.documentLocation ?? '', 'application/pdf');
                    onSelectedCVName?.(cv?.documentFileName ?? '');
                    // onSelect(
                    //   cv?.isMappedCandidateResumes
                    //     ? cv?.candidateResume[0]?.resumeLocation ?? ''
                    //     : cv?.resumeLocation ?? '',
                    //   'application/pdf'
                    // );
                    // onSelectedCVName?.(
                    //   cv?.isMappedCandidateResumes
                    //     ? cv?.candidateResume[0]?.resumeFileOriginalName ??
                    //         cv?.candidateResume[0]?.s3FileName ??
                    //         ''
                    //     : cv?.resumeFileOriginalName
                    // );
                    amplitude('CandidateView_CV_SelectCV', {
                      clickedOn: 'Select CV',
                      pageName: 'candidate-layout',
                      pageUrl: window.location.href,
                    });
                  }}
                />
              ))
            ) : (
              <EmptyContentMessage
                title="No CV"
                subtitle="Oops! Candidate CVs are not available."
              />
            )}
          </>
        )}
        {currentTab == 1 && (
          <>
            {otherDocuments.length > 0 ? (
              otherDocuments?.map((i: OtherDocuments, index) => (
                <DocumentCard
                  fileType={i.type ?? 'application/pdf'}
                  key={index}
                  title={i.resumeFileName ?? i.originalName ?? ''}
                  date={
                    i.resumeUploadedOn
                      ? formateDateForNewSubmission(i.resumeUploadedOn)
                      : i.uploadedOn
                      ? formateDateForNewSubmission(i.uploadedOn)
                      : ''
                  }
                  isSelected={selectedIndex === index}
                  onClick={() => handleDocumentSelect(index, i)}
                  jobTitle={i.jobTitle}
                  jobCode={i.jobCode}
                  recruiterEmail={i.recruiterEmail}
                />
              ))
            ) : (
              <EmptyContentMessage
                title="No Documents"
                subtitle="Oops! Candidate Documents are not available."
                // marginLeft="50px"
              />
            )}
          </>
        )}
      </Grid>
      <UploadFile open={openUpload} setOpen={setOpenUpload} />
    </Grid>
  );
};
export default LeftPane;
